import { App, useQueryApps } from "@zapier/client";
import { ZapLike } from "@zapier/shared";
import { useMemo } from "react";
import uniq from "lodash.uniq";

interface Input {
  zaps: ZapLike[];
}

// Takes a list of Zaps and returns a hash of Apps that those
// Zaps reference in their ZDL

export function useAppsFromZapsList({ zaps }: Input) {
  const selectedApis = useMemo(() => {
    const apis = zaps.reduce((accumulator, zap) => {
      const steps =
        zap.currentVersion?.zdl?.steps || zap.draft?.zdl?.steps || [];
      steps.forEach((step) => {
        if (step.app) {
          accumulator.push(step.app);
        }
      });
      return accumulator;
    }, [] as string[]);

    return uniq(apis);
  }, [zaps]);

  const { apps } = useQueryApps({ selectedApis });

  const hashedApps = useMemo(() => {
    return apps.reduce(
      (accumulator, app) => {
        if (app.currentImplementationId) {
          accumulator[app.currentImplementationId] = app;
        }
        return accumulator;
      },
      {} as Record<string, App>,
    );
  }, [apps]);

  return hashedApps;
}
